import entries from 'lodash/entries'
import { css } from 'styled-components'

export const BREAKPOINT_SIZE_DIGIT = {
  mobileMin: 320,
  mobileMax: 767,
  tabletMin: 768,
  tabletMax: 1024,
  desktopMin: 1025,
  desktopSmall: 1280,
  desktopMedium: 1440,
  desktopLarge: 1920,
  desktopMax: 2560,
}

export const BREAKPOINT_SIZE = entries(BREAKPOINT_SIZE_DIGIT).reduce(
  (acc, [key, value]) => {
    acc[key as keyof typeof BREAKPOINT_SIZE_DIGIT] = `${value}px`
    return acc
  },
  {} as Record<keyof typeof BREAKPOINT_SIZE_DIGIT, string>
)

export const FONT_SIZE = {
  '12': css`
    font-size: 12px;
    line-height: 15px;
  `,
  '13': css`
    font-size: 13px;
    line-height: 17px;
  `,
  '14': css`
    font-size: 14px;
    line-height: 18px;
  `,
  '16': css`
    font-size: 16px;
    line-height: 21px;
  `,
  '18': css`
    font-size: 18px;
    line-height: 23px;
  `,
  '20': css`
    font-size: 20px;
    line-height: 26px;
  `,
  '22': css`
    font-size: 22px;
    line-height: 28px;
  `,
  '24': css`
    font-size: 24px;
    line-height: 31px;
  `,
  '26': css`
    font-size: 26px;
    line-height: 33px;
  `,
  '28': css`
    font-size: 26px;
    line-height: 34px;
  `,
  '32': css`
    font-size: 32px;
    line-height: 41px;
  `,
  '40': css`
    font-size: 40px;
    line-height: 52px;
  `,
  '48': css`
    font-size: 48px;
    line-height: 58px;
  `,
} as const

export const SPACE = {
  '0': '0px',
  '0.5': '2px',
  '1': '4px',
  '1.5': '6px',
  '2': '8px',
  '2.5': '10px',
  '3': '12px',
  '3.5': '14px',
  '4': '16px',
  '5': '20px',
  '6': '24px',
  '7': '28px',
  '8': '32px',
  '9': '36px',
  '10': '40px',
  '11': '44px',
  '12': '48px',
  '14': '56px',
  '16': '64px',
  '20': '80px',
  '24': '96px',
  '28': '112px',
  '32': '128px',
  '36': '144px',
  '40': '160px',
  '44': '176px',
  '48': '192px',
  '52': '208px',
  '56': '224px',
  '60': '240px',
  '64': '256px',
  '72': '288px',
  '80': '320px',
  '96': '384px',
} as const

export const MARGINS = {
  $m: (value: string) => css`
    margin: ${value};
  `,
  $mx: (value: string) => css`
    margin-left: ${value};
    margin-right: ${value};
  `,
  $my: (value: string) => css`
    margin-top: ${value};
    margin-bottom: ${value};
  `,
  $ms: (value: string) => css`
    margin-inline-start: ${value};
  `,
  $me: (value: string) => css`
    margin-inline-end: ${value};
  `,
  $mt: (value: string) => css`
    margin-top: ${value};
  `,
  $mr: (value: string) => css`
    margin-right: ${value};
  `,
  $mb: (value: string) => css`
    margin-bottom: ${value};
  `,
  $ml: (value: string) => css`
    margin-left: ${value};
  `,
}

export const PADDINGS = {
  $p: (value: string) => css`
    padding: ${value};
  `,
  $px: (value: string) => css`
    padding-left: ${value};
    padding-right: ${value};
  `,
  $py: (value: string) => css`
    padding-top: ${value};
    padding-bottom: ${value};
  `,
  $ps: (value: string) => css`
    padding-inline-start: ${value};
  `,
  $pe: (value: string) => css`
    padding-inline-end: ${value};
  `,
  $pt: (value: string) => css`
    padding-top: ${value};
  `,
  $pr: (value: string) => css`
    padding-right: ${value};
  `,
  $pb: (value: string) => css`
    padding-bottom: ${value};
  `,
  $pl: (value: string) => css`
    padding-left: ${value};
  `,
}
